<template>
  <div class="about">
    <div class="cta flex flex-row justify-evenly flex-wrap my-4 items-center">
      <div class="cta-text">
        <h3 class="text-red-500 my-4 font-bold h">Drone delivery Services</h3>
        <p class="my-1">
          We help save lives by ensuring blood suples and donated blood reaches patients on time. </p>
        <p class="my-4">Irrespective of the location, our core principle of saving lives comes first, we ensure timely and quality delivery of donated blood to accident victims, hospital emergencies and other emergencies. </p>
      </div>
      <div class="cta-img">
        <img
          src="/img/Frame.png"
          alt=""
        >
      </div>
    </div>
    <div class="cta text-center">
      <h3 class="uppercase text-red-500 my-4 font-bold ">Our Core Values</h3>
      <div class="card-container flex flex-row justify-evenly flex-wrap">
        <div class="card">
          <h4>Deliver Results</h4>
          <img
            src="/img/deliver.svg"
            alt="deliver"
          >
            <p>We always work hard to ensure timely delivery of results to satisfy our clients</p>
        </div>
        <div class="card">
          <h4>Speed</h4>
          <img
            src="/img/speed.svg"
            alt="speed"
          >
            <p>We ensure that our delivery comes in on time as speed is one of our major focus to saving lives</p>
        </div>
        <div class="card">
          <h4>Customer Centric</h4>
          <img
            src="/img/reviews.svg"
            alt="review"
          >
            <p>We always put our customers first and take customer reviews seriously</p>
        </div>
        <div class="card">
          <h4>Quality</h4>
          <img
            src="/img/quality.svg"
            alt="quality"
          >
            <p>We ensure maximum quality of blood delivery to the right client</p>
        </div>
      </div>
    </div>
    <div class="cta ">
      <h3 class="uppercase text-red-500 text-center my-4 font-bold">MEET OUR TEAMS</h3>
      <div class="card-container flex flex-row flex-wrap justify-evenly">
        <div class="rounded max border md:shadow w-full md:w-64 overflow-hidden">
          <div>
            
              <img
                class="object-cover"
                src="/img/img2.png"
                alt="card 1"
              />
            
          </div>

          <div class="px-4 py-4 text-center"><h3 class="font-semibold text-gray-800 my-1  text-lg">
              Eric
            </h3>
            <div class="text-xs text-gray-600 my-1 font-medium">
              
                Full Stack Developer
            </div>

            
            <p class="text-center text-sm font-thin">include designing user interactions on websites, developing servers, and databases.</p>
            
          </div>
        </div>
        <div class="rounded max border md:shadow w-full md:w-64 overflow-hidden">
          <div>
            
              <img
                class="object-cover"
                src="/img/img3.png"
                alt="card 1"
              />
            
          </div>

          <div class="px-4 py-4 text-center"><h3 class="font-semibold text-gray-800 my-1  text-lg">
              Sarah
            </h3>
            <div class="text-xs text-gray-600 my-1 font-medium">
              
                Full Stack Developer
            </div>

            
            <p class="text-center text-sm font-thin">include designing user interactions on websites, developing servers, and databases.</p>

            
          </div>
        </div>
        <div class="rounded max border md:shadow w-full md:w-64 overflow-hidden">
          <div>
            
              <img
                class="object-cover"
                src="/img/img1.png"
                alt="card 1"
              />
            
          </div>

          <div class="px-4 py-4 text-center"> <h3 class="font-semibold text-gray-800 my-1  text-lg">
              Dan
            </h3>
            <div class="text-xs text-gray-600 my-1 font-medium">
              
                Full Stack Developer
            </div>

           
            <p class="text-center text-sm font-thin">include designing user interactions on websites, developing servers, and databases.</p>

            
          </div>
        </div>
        <div class="rounded max border md:shadow w-full md:w-64 overflow-hidden">
          <div>
            
              <img
                class="object-cover"
                src="/img/img4.png"
                alt="card 1"
              />
            
          </div>

          <div class="px-4 py-4 text-center"><h3 class="font-semibold text-gray-800 my-1  text-lg">
              Rich
            </h3>
            <div class="text-xs text-gray-600 my-1 font-medium">
              
                Full Stack Developer
            </div>

            
            <p class="text-center text-sm font-thin">include designing user interactions on websites, developing servers, and databases.</p>

            
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<style lang="scss" scoped>
.cta-text {
  max-width: 25em;
}
.h {
  font-size: 2.3em !important;
}
p {
  font-weight: 500;
}
.cta-img {
  max-width: 30em;
}
.max{
 max-width: 20em;
 margin: 1em;
}
@media (max-width: 768px) {
  .cta-img {
    width: 90%;
    img {
      width: 100%;
    }
  }
  .cta-text {
    text-align: center;
    order: 1;
  }
}
.cta {
  margin: 3em 0 5em 0;
}
.card-container {
  width: 90%;
  margin:0 auto;
  .card {
    max-width: 15em;
    text-align: center;
    h4 {
      font-size: 1.5em;
      font-weight: 600;
    }
    img {
      margin: 1em auto;
    }
  }
}
</style>

